import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '@guards/auth.guard';
import { DetailsModule } from '@pages/details/details.module';
import { FinalizeOrderModule } from '@pages/finalize-order/finalize-order.module';
import { OrderConfirmationModule } from '@pages/order-confirmation/order-confirmation.module';
import { OverviewModule } from '@pages/overview/overview.module';
import { OverviewResolver } from '@pages/overview/overview.resolver';
import { PrivatePageComponent } from '@pages/private-pages/private-page.component';
import { ComponentsModule } from 'src/app/shared/components/components.module';
import { ChangeFlightConfirmationResolver } from './change-flight-confirmation/change-flight-confirmation.resolver';
import { ExtrasPageModule } from './extras-page/extras-page.module';
import { OverviewComponent } from './overview/overview.component';
import { ResultPageResolver } from './result-page/result-page.resolver';
import { PassengerChangeModule } from './passenger-change/passenger-change.module';
import { UrlPathnameEnum } from '@enums/url-pathname.enum';
import { CancelOrderModule } from '@pages/cancel-order/cancel-order.module';

const routes: Routes = [
  {
    path: '',
    component: PrivatePageComponent,
    children: [
      {
        path: UrlPathnameEnum.Overview,
        component: OverviewComponent,
        canActivate: [AuthGuard],
        resolve: {
          incomingData: OverviewResolver,
        },
      },
      {
        path: UrlPathnameEnum.Result,
        loadChildren: () => import('./result-page/result-page.module').then((m) => m.ResultPageModule),
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard],
        resolve: { incomingData: ResultPageResolver },
      },
      {
        path: UrlPathnameEnum.Confirmation,
        loadChildren: () =>
          import('./change-flight-confirmation/change-flight-confirmation.module').then((m) => m.ChangeFlightConfirmationModule),
        canActivate: [AuthGuard],
        resolve: { incomingData: ChangeFlightConfirmationResolver },
      },
      {
        path: UrlPathnameEnum.Extras,
        canActivate: [AuthGuard],
        loadChildren: () => import('./extras-page/extras-page.module').then((m) => m.ExtrasPageModule),
      },
      {
        path: UrlPathnameEnum.PassengerChange,
        canActivate: [AuthGuard],
        loadChildren: () => import('./passenger-change/passenger-change.module').then((m) => m.PassengerChangeModule),
      },
      {
      path: UrlPathnameEnum.SplitPnr,
      canActivate: [AuthGuard],
      loadChildren: () => import('./split-pnr/split-pnr.module').then((m) => m.SplitPnrModule),
      },
      { path: '', redirectTo: '/overview', pathMatch: 'full' },
      {
        path: UrlPathnameEnum.CommonOrder,
        loadChildren: () => import('./common-order/common-order.module').then((m) => m.CommonOrderModule),
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard],
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {}),
    CommonModule,
    ComponentsModule,
    OverviewModule,
    DetailsModule,
    FinalizeOrderModule,
    OrderConfirmationModule,
    ExtrasPageModule,
    PassengerChangeModule,
  ],
  declarations: [PrivatePageComponent],
  exports: [RouterModule],
})
export class PrivateRoutesModule {}